import { render } from "./NavBarView.vue?vue&type=template&id=0ff1ed18&scoped=true"
const script = {}

import "./NavBarView.vue?vue&type=style&index=0&id=0ff1ed18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff1ed18"]])

export default __exports__